import { useEffect, useRef, useState } from "react";

/**
 * Editorial-style custom cursor accent, subtle dot that grows over interactive elements.
 * Desktop / fine-pointer only (CSS-guarded).
 */
export default function CursorAccent() {
  const dotRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const ok =
      window.matchMedia("(hover: hover) and (pointer: fine)").matches &&
      !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!ok) return;
    setEnabled(true);

    const dot = dotRef.current;
    let tx = -100;
    let ty = -100;
    let cx = -100;
    let cy = -100;
    let rafId;

    const move = (e) => {
      tx = e.clientX;
      ty = e.clientY;
    };
    const overInteractive = (e) => {
      if (!dot) return;
      const el = e.target;
      const interactive = el.closest("a, button, [role='button'], input, textarea, label, [data-cursor='hover']");
      dot.classList.toggle("is-hovering", Boolean(interactive));
    };
    const tick = () => {
      cx += (tx - cx) * 0.22;
      cy += (ty - cy) * 0.22;
      if (dot) dot.style.transform = `translate3d(${cx}px, ${cy}px, 0) translate(-50%, -50%)`;
      rafId = requestAnimationFrame(tick);
    };

    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseover", overInteractive, { passive: true });
    rafId = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", overInteractive);
      cancelAnimationFrame(rafId);
    };
  }, []);

  if (!enabled) return null;
  return <div ref={dotRef} className="cursor-dot" aria-hidden data-testid="cursor-accent" />;
}
